<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { useDesign } from '@/hooks/web/useDesign'
// import { ElNotification } from 'element-plus'
// import { useCommon } from '@/store/modules/common'
import { domain } from '@/utils/domain'
import { useCommon } from '@/store/modules/common'
const { getPrefixCls } = useDesign()

useCommon().setDomain()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

appStore.initTheme()

// const getDomainData = async () => {

//   const res = await domain()
//   localStorage.setItem('domain', JSON.stringify(res))
// }
if (!localStorage.getItem('domain')) {
  const useCommonData = useCommon()
  useCommonData.setDomain()
}
// if (JSON.parse(localStorage.getItem('userInfo'))&&JSON.parse(localStorage.getItem('userInfo')).user_Phone) {
//   localStorage.setItem('userInfo', JSON.stringify(JSON.parse(localStorage.getItem('userInfo')).user_Phone))
// } else {
//   localStorage.setItem('userInfo', JSON.stringify(JSON.parse(localStorage.getItem('userInfo'))..user_Phone))
// }
// document.cookie = `account=${localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).user_Name : ''};domain=cccbn.cn;`
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
  </ConfigGlobal>
</template>

<style lang="less">
@import '/public/font/iconfont.css';
@import '@/styles/detail.less';

.el-scrollbar__bar {
  display: block !important;
}

.el-button--danger {
  background-color: #b13a23 !important;
}
.dark {
  font-family: none;
  font-size: 16px;
  line-height: auto;
}
@prefix-cls: ~'@{adminNamespace}-app';

// bootstrap上传图片问题
.el-upload__input {
  display: none !important;
}
// 表格高度问题
.cell {
  height: auto !important;
}

.searchBox {
  background-color: #edf3fe !important;
  padding: 20px 50px !important;
  margin-bottom: 10px;
  border-radius: 10px !important;
  border: none !important;
}

.dataTable tr td {
  table-layout: fixed;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
  -o-text-overflow: ellipsis;
  height: 48px;
}

.el-table--border .el-table__cell {
  border-right: 1px solid #f5f5f5 !important;
}

.el-table th.el-table__cell.is-leaf {
  background-color: #efefef !important;
}

.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background-color: #efefef !important;
}

.size {
  width: 100%;
  height: 100%;
}

// >>> .btn-info {
//   background-color: #5393fb;
// }

html,
body {
  font-family: 'Roboto', sans-serif;
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
  }
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}

.btn-info {
  background-color: #dbe8fe !important;
  border-color: #5393fb !important;
  color: #5393fb !important;
}
.btn-info:hover {
  background-color: #5393fb !important;
  border-color: #5393fb !important;
  color: #dbe8fe !important;
}
.btn-primary {
  background-color: #ebf3fb !important;
  border-color: #609fd6 !important;
  color: #609fd6 !important;
}
.btn-primary:hover {
  background-color: #609fd6 !important;
  border-color: #609fd6 !important;
  color: #ebf3fb !important;
}
.btn-success {
  background-color: #eef6e8 !important;
  border-color: #66b840 !important;
  color: #66b840 !important;
}
.btn-success:hover {
  background-color: #66b840 !important;
  border-color: #66b840 !important;
  color: #eef6e8 !important;
}
.btn-default {
  background-color: #f4f4f5 !important;
  border-color: #9b9ea3 !important;
  color: #9b9ea3 !important;
}
.btn-default:hover {
  background-color: #9b9ea3 !important;
  border-color: #9b9ea3 !important;
  color: #f4f4f5 !important;
}
.btn-info2 {
  background-color: #e2ffff !important;
  border-color: #007680 !important;
  color: #007680 !important;
}
.btn-info2:hover {
  background-color: #007680 !important;
  border-color: #007680 !important;
  color: #e2ffff !important;
}
.btn-warning {
  background-color: #ffe9c0 !important;
  border-color: #b97d00 !important;
  color: #b97d00 !important;
}
.btn-warning:hover {
  background-color: #b97d00 !important;
  border-color: #b97d00 !important;
  color: #ffe9c0 !important;
}
.btn-danger {
  background-color: #ffe0e4 !important;
  border-color: #b13a23 !important;
  color: #b13a23 !important;
}
.btn-danger:hover {
  background-color: #b13a23 !important;
  border-color: #b13a23 !important;
  color: #ffe0e4 !important;
}

.btn {
  margin: 0px 5px !important;
}
</style>
